(function () {
  "use strict";

  var DEFAULT_EXPERIMENT_ID = "social_app_browser_redirect";
  var PARAM_EXPERIMENT = "ub_iab_exp";
  var PARAM_VARIANT = "ub_iab_variant";
  var PARAM_SOURCE = "ub_iab_source";
  var PARAM_REDIRECTED = "ub_iab_redirected";
  var COOKIE_DAYS = 30;

  function detectSource(userAgent) {
    if (/instagram/i.test(userAgent)) return "instagram";
    if (/(FBAN|FBAV|FB_IAB|FB4A|FBIOS|FBLC|FBOP|MessengerForiOS|Orca-Android)/i.test(userAgent)) {
      return "facebook";
    }
    return "";
  }

  function detectPlatform(userAgent) {
    if (/android/i.test(userAgent)) return "android";
    if (/iphone|ipad|ipod/i.test(userAgent)) return "ios";
    if (/macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1) return "ios";
    return "";
  }

  function getIOSMajorVersion(userAgent) {
    var match = userAgent.match(/OS (\d+)[_.]/i);
    return match ? parseInt(match[1], 10) : 0;
  }

  function getEnvironment() {
    var userAgent = navigator.userAgent || "";
    var source = detectSource(userAgent);
    var platform = detectPlatform(userAgent);

    return {
      eligible: Boolean(source && platform),
      platform: platform,
      source: source,
      userAgent: userAgent,
    };
  }

  function writeCookie(name, value) {
    var maxAge = COOKIE_DAYS * 24 * 60 * 60;
    var cookie = name + "=" + encodeURIComponent(value) + "; Path=/; Max-Age=" + maxAge + "; SameSite=Lax";
    if (window.location.protocol === "https:") cookie += "; Secure";
    document.cookie = cookie;
  }

  function track(eventName, detail) {
    var payload = Object.assign({
      event: eventName,
      experiment_id: DEFAULT_EXPERIMENT_ID,
    }, detail || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
    }

    return payload;
  }

  function buildDestinationUrl(currentUrl, detail) {
    var destinationUrl = new URL(currentUrl.href);

    destinationUrl.searchParams.set(PARAM_EXPERIMENT, detail.experimentId);
    destinationUrl.searchParams.set(PARAM_VARIANT, detail.variant);
    destinationUrl.searchParams.set(PARAM_SOURCE, detail.source);
    destinationUrl.searchParams.set(PARAM_REDIRECTED, "1");

    return destinationUrl;
  }

  function buildRedirectUrl(destinationUrl, environment) {
    if (environment.platform === "ios") {
      if (getIOSMajorVersion(environment.userAgent) >= 17) {
        return "x-safari-" + destinationUrl.href;
      }

      return "com-apple-mobilesafari-tab:" + destinationUrl.href;
    }

    var intentDestination = new URL(destinationUrl.href);
    intentDestination.hash = "";

    return "intent://"
      + intentDestination.href.replace(/^https?:\/\//i, "")
      + "#Intent;scheme=" + destinationUrl.protocol.replace(":", "")
      + ";action=android.intent.action.VIEW"
      + ";category=android.intent.category.BROWSABLE"
      + ";S.browser_fallback_url=" + encodeURIComponent(destinationUrl.href)
      + ";end";
  }

  function cleanRedirectParameters(currentUrl) {
    var cleanUrl = new URL(currentUrl.href);

    cleanUrl.searchParams.delete(PARAM_EXPERIMENT);
    cleanUrl.searchParams.delete(PARAM_VARIANT);
    cleanUrl.searchParams.delete(PARAM_SOURCE);
    cleanUrl.searchParams.delete(PARAM_REDIRECTED);

    window.history.replaceState({}, "", cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
  }

  function handleRedirectLanding() {
    var currentUrl = new URL(window.location.href);

    if (currentUrl.searchParams.get(PARAM_REDIRECTED) !== "1") return null;

    var environment = getEnvironment();
    var detail = {
      experiment_id: currentUrl.searchParams.get(PARAM_EXPERIMENT) || DEFAULT_EXPERIMENT_ID,
      experiment_variant: currentUrl.searchParams.get(PARAM_VARIANT) || "treatment",
      social_app_browser: currentUrl.searchParams.get(PARAM_SOURCE) || environment.source || "unknown",
      social_app_browser_platform: environment.platform || "unknown",
      redirect_result: environment.source ? "in_app_browser" : "native_browser",
    };

    writeCookie("ub_iab_redirect_variant", detail.experiment_variant);
    writeCookie("ub_iab_redirect_source", detail.social_app_browser);
    track("unbound_social_app_browser_redirect_landed", detail);
    cleanRedirectParameters(currentUrl);

    return detail;
  }

  function openNativeBrowser(options) {
    var config = options || {};
    var environment = getEnvironment();
    var detail = {
      experiment_id: config.experimentId || DEFAULT_EXPERIMENT_ID,
      experiment_variant: config.variant || "treatment",
      social_app_browser: environment.source || "unknown",
      social_app_browser_platform: environment.platform || "unknown",
    };

    if (!environment.eligible) {
      detail.redirect_result = "not_eligible";
      track("unbound_social_app_browser_redirect_skipped", detail);
      return { eligible: false, result: detail.redirect_result, detail: detail };
    }

    var destinationUrl = buildDestinationUrl(new URL(window.location.href), {
      experimentId: detail.experiment_id,
      variant: detail.experiment_variant,
      source: detail.social_app_browser,
    });
    var redirectUrl = buildRedirectUrl(destinationUrl, environment);

    detail.redirect_result = "attempted";
    track("unbound_social_app_browser_redirect_attempted", detail);

    try {
      window.location.replace(redirectUrl);
    } catch (error) {
      detail.redirect_result = "error";
      detail.error_message = error && error.message ? error.message : "redirect_error";
      track("unbound_social_app_browser_redirect_error", detail);
      return { eligible: true, result: "error", detail: detail };
    }

    window.setTimeout(function () {
      if (document.visibilityState === "hidden") return;

      detail.redirect_result = "blocked_or_stayed";
      track("unbound_social_app_browser_redirect_blocked", detail);
    }, 1200);

    return { eligible: true, result: "attempted", redirectUrl: redirectUrl, detail: detail };
  }

  function trackControl(options) {
    var config = options || {};
    var environment = getEnvironment();
    var detail = {
      experiment_id: config.experimentId || DEFAULT_EXPERIMENT_ID,
      experiment_variant: config.variant || "control",
      social_app_browser: environment.source || "unknown",
      social_app_browser_platform: environment.platform || "unknown",
      redirect_result: "control",
    };

    track("unbound_social_app_browser_redirect_control", detail);
    return detail;
  }

  window.UnboundSocialAppBrowserRedirect = {
    buildRedirectUrl: buildRedirectUrl,
    detectPlatform: detectPlatform,
    detectSource: detectSource,
    getEnvironment: getEnvironment,
    handleRedirectLanding: handleRedirectLanding,
    openNativeBrowser: openNativeBrowser,
    trackControl: trackControl,
  };

  try {
    handleRedirectLanding();
  } catch (error) {
    track("unbound_social_app_browser_redirect_landing_error", {
      error_message: error && error.message ? error.message : "landing_error",
    });
  }
})();
